import { initialState } from "./../initialState";
import * as DashboardActions from "./dashboardActions";

export const dashboardReducer = (state = initialState.dashboard, action) => {
    switch (action.type) {
        case DashboardActions.OPEN_SIDEBAR:
            return Object.assign({}, state, {
                open: true,
            });

        case DashboardActions.CLOSE_SIDEBAR:
            return Object.assign({}, state, {
                open: false,
            });
        case DashboardActions.CLEAR_CREATION_DATE:
            return Object.assign({}, state, {
                creationDate: {
                    startDate: "",
                    endDate: "",
                },
            });
        case DashboardActions.SET_CREATION_DATE:
            return Object.assign({}, state, {
                creationDate: action.creationDate,
            });
        case DashboardActions.FILTER_DASHBOARD:
            return Object.assign({}, state, {
                filter: action.filter,
                zones: {
                    items: [],
                    all: true,
                },
            });

        case DashboardActions.CLEAR_FILTER:
            return Object.assign({}, state, {
                filter: {
                    items: [],
                    all: true,
                },
                zones: {
                    items: [],
                    all: true,
                },
            });
        case DashboardActions.CLEAR_WORKORDER_ID:
            return {
                ...state,
                workOrderNumber: initialState.dashboard.workOrderNumber,
            };
        case DashboardActions.ZONESELECTED_DASHBOARD:
            return Object.assign({}, state, {
                zones: action.zones,
            });

        case DashboardActions.ALLSTATUS_DASHBOARD:
            return Object.assign({}, state, {
                allStatuses: action.allStatuses,
            });
        case DashboardActions.CLEAR_ALLSTATUS:
            return Object.assign({}, state, {
                allStatuses: {
                    items: [],
                    all: false,
                },
            });
        case DashboardActions.GET_ALL_FILTERS_DATA:
            return Object.assign({}, state, {
                filter: action.data.filter,
                zones: {
                    items: [],
                    all: true,
                },
                allStatuses: action.data.allStatuses,
                creationDate: action.data.creationDate,
                workOrderNumber: action.data.workOrderNumber,
            });

        default:
            return state;
    }
};
